<template>
  <div>
    <baseFrame
      save-text=""
      clear-text=""
      submit-text="提交"
      :submit-loading="submitLoading"
      @submit="submitConfirm"
      @cancel="handleToList">
      <div slot="content">
        <lk-card>
          <lk-form
            ref="form"
            label-position="right"
            :model="formModel"
            :label-width="134">
            <lk-row :gutter="16">
              <lk-col span="23">
                <lk-form-item label="批号修改明细:">
                  <lk-button type="primary" @click="handleAdd">新增</lk-button>
                  <span class="red"> 仅适用于采购入库时录错批号的修正！因出库错误导致的库存批号修正请使用库存盘点损溢单！</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter="16">
              <lk-col span="23">
                <div class="" style="margin-left: 134px;">
                  <lk-table border :columns="columns" :data="formModel.tableData">
                    <template slot-scope="{ row, index }" slot="socialUnifyCreditCodeName">
                      <lk-form-item
                        :prop="'tableData.' + index + '.socialUnifyCreditCode'"
                        :label-width="0"
                        :rules="[{required: true, tigger: 'blur', message: '请输入..'},{validator: validSocialUnifyCreditCode, tigger: 'blur' }]"
                      >
                        <lk-input
                          clearable
                          placeholder="请输入"
                          @on-change="validFormItem($event, row, index)"
                          v-model.trim="row.socialUnifyCreditCode">
                        </lk-input>
                      </lk-form-item>
                    </template>

                  </lk-table>
                </div>
              </lk-col>
            </lk-row>
          </lk-form>
        </lk-card>
      </div>
    </baseFrame>
    <DTPModal
      v-model="submitConfirmVisiable"
      content="商品批号被修改，确认提交？"
      :confirmLoading="submitLoading"
      @confirm="submit"
      @handleCancel="submitConfirmVisiable = false">
    </DTPModal>
    <lk-modal
      v-model="modalVisiable"
      :mask-closable="false"
      title="选择商品"
      width="900">
      <div class="queryContainer">
        <div class="queryItem">
          <goodsSearchItem v-model="modalQuery.nameMix" placeholder='支持商品编码、通用名、商品名'></goodsSearchItem>
        </div>
        <div class="queryItem">
          <label>验收时间：</label>
          <timeStampDatePicker class="item" v-model="modalQuery.createTime" clearable></timeStampDatePicker>
        </div>
        <div class="queryItem">
          <lk-button type="primary" class="mr8" @click="handleModalSearch">查询</lk-button>
          <lk-button @click="clearModalQuery" class="mr8">重置</lk-button>
        </div>
      </div>
      <div style="position: relative;">
        <LoadingSpan v-show="modalLoading"></LoadingSpan>
        <lk-table
          border
          height="400"
          :columns="modalColumns"
          :data="modalTableData"
          @on-select="handleTempSelect"
          @on-select-cancel="handleTempCancel"
          @on-select-all="handleSelectAll"
          @on-select-all-cancel="handleSelectAllCancel">
        </lk-table>
      </div>
      <div style="margin-top: 14px; text-align: right;">
        <lk-page
          :total="modalPage.count"
          :page-size="modalPage.size"
          :current="modalPage.page"
          size="small"
          show-sizer
          show-total
          show-elevator
          @on-change="handleModalPage"
          @on-page-size-change="handleModalSize">
        </lk-page>
      </div>
      <div slot="footer">
        <div class="queryItem">
          <span style="padding-right: 16px;">已选:{{this.tempSelection.length + this.formModel.tableData.length}}项</span>
          <lk-button @click="hideModal">取消</lk-button>
          <lk-button type="primary" class="mr" @click="pushModalData">确定</lk-button>
        </div>
      </div>
    </lk-modal>
  </div>
</template>
<script>
import baseFrame from '../../components/frame/BaseFrame.vue';
import toolsService from '../../services/tools';
import toolsGoodsMixins from '../../mixins/toolsGoodsMixins';
import goodsService from '../../services/goods';
import utils from '../../libs/utils';
import DTPModal from '../../components/DTPModal';
import LoadingSpan from '../../components/LoadingSpan.vue';

export default {
  name: 'outputTaxRateAdd',
  mixins: [toolsGoodsMixins],
  components: {
    baseFrame,
    DTPModal,
    LoadingSpan,
  },
  data() {
    return {
      formModel: {
        tableData: [],
      },
      formRules: [
        { required: true, message: '请选择...' },
        { validator: this.validrealOutputTaxRate },
      ],
      submitConfirmVisiable: false,
      submitLoading: false,
      columns: [
        { title: '商品编码', key: 'drugSerialCode', minWidth: 116 },
        {
          title: '通用名',
          key: 'approvedDrugNames',
          minWidth: 130,
        },
	      { title: '进价', key: 'price', minWidth: 116 },
	      { title: '批次', key: 'batchSeq', minWidth: 116 },
	      { title: '原批号', key: 'oldBatchNumber', minWidth: 116 },
	      {
	      	title: '修改后批号',
          slot: 'batchNumber',
          minWidth: 116,
        },
	      {
		      title: '批准文号',
		      key: 'approvalNumber',
		      minWidth: 116,
	      },
        {
          title: '规格',
          key: 'specifications',
          minWidth: 116,
        },
        { title: '生产企业', key: 'manufacturer', minWidth: 116 },
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 130,
          render: (h, { index }) => h('lk-button', {
            props: {
              type: 'text',
            },
            on: {
              click: () => {
                this.formModel.tableData.splice(index, 1);
                this.$Message.success('删除成功');
                this.$nextTick(() => {
                  this.formModel.tableData.forEach((item, index2) => {
                    this.validSingleItemByIndex(index2);
                  });
                });
              },
            },
          }, '删除'),
        },
      ],
      modalColumns: [
        {
          title: '选择', key: 'id', type: 'selection', width: 60,
        },
        { title: '商品编码', key: 'drugSerialCode', minWidth: 116 },
        { title: '药品通用名', key: 'approvedDrugNames', minWidth: 156 },
        { title: '批号', key: 'batchSeq', minWidth: 156 },
        { title: '批次', key: 'batchNumber', minWidth: 156 },
        { title: '批准文号/注册证号', key: 'approvalNumberStr', minWidth: 166 },
        { title: '规格', key: 'specifications', minWidth: 116 },
        { title: '生产企业', key: 'manufacturer', minWidth: 186 },
        // { title: '商品类型', key: 'typeString', minWidth: 156 },
        // { title: '剂型', key: 'dosageFormString', minWidth: 116 },
        // { title: '药品最小包装单位', key: 'drugMiniPackageUnitString', minWidth: 166 },
        // { title: '储存条件', key: 'storageConditionsString', minWidth: 116 },
        // { title: '本位码', key: 'ndcNumber', minWidth: 116 },
        // { title: '产地', key: 'countryOfOrigin', minWidth: 116 },
        // { title: '质检标准', key: 'drugAcceptanceStandard', minWidth: 116 },
        // { title: '批件号', key: 'drugRegApprovalCode', minWidth: 166 },
        // { title: '批件有效期', key: 'periodDrugRegApproval', minWidth: 166 },
        // { title: '商品名称', key: 'goodsName', minWidth: 116 },
        // { title: '化学成分', key: 'chemicalComposition', minWidth: 116 },
        // { title: '条形码', key: 'barCode', minWidth: 116 },
        // { title: '是否进口', key: 'isImport', minWidth: 116 },
        // {
        //   title: '商品标签', key: 'goodsLabelsString', minWidth: 156, tooltip: true,
        // },
        // { title: '商品分类', key: 'indicationDicString', minWidth: 156 },
        // {
        //   title: '状态',
        //   minWidth: 116,
        //   key: 'baseInfoStatus',
        //   render: (h, { row }) => h('span', row.goodsBaseStatus === 1 ? '启用' : '禁用'),
        // },
      ],
    };
  },
  computed: {
    taxRateList() {
      return this.$store.state.publicParams.taxRateList;
    },
  },
  methods: {
    handleToList() {
      this.$router.push({
        name: 'batchNumberList',
      });
    },
    validrealOutputTaxRate(rule, value, callback) {
      if (value) {
        callback();
      }
      callback();
    },
    validSingleItemByIndex(index) {
      this.$refs.form.validateField(`tableData.${index}.realOutputTaxRate`);
    },
    validFormItem(value, item, index) {
      item.realOutputTaxRate = value;
      this.formModel.tableData[index] = item;
      this.$nextTick(() => {
        if (utils.isEmpty(value)) { // 重新触发验证
          this.validSingleItemByIndex(index);
        }
      });
    },
    // todo 弹出层增加销售订单号
    getModalData() {
      this.modalParams.page = this.modalPage.page;
      this.modalParams.size = this.modalPage.size;
      this.$store.commit('setDisableLoading', true);
      this.modalLoading = true;
      goodsService.listGoodsBases(this.modalParams).then((res) => {
        if (res.data.status === 200) {
          const { count, list } = res.data.data;
          this.modalTableData = [];
          list.forEach((item) => {
            const result = this.exchangeGoodsBase(item);
            result._checked = this.selectedIds.includes(result.id) || this.tempSelectionIds.includes(result.id);
            result._disabled = this.selectedIds.includes(result.id);
            result.realOutputTaxRate = result.realOutputTaxRate || 0;
            this.modalTableData.push(result);
          });
          this.modalPage.count = count;
        } else {
          this.$Message.error(res.data.error);
        }
        this.modalLoading = false;
      }).catch((err) => {
        this.modalLoading = false;
        utils.handleError(err);
      });
    },
    submit() {
      const params = [];
      this.formModel.tableData.forEach((item) => {
        params.push({
          goodsBaseId: item.originGoodsBaseId,
          realOutputTaxRate: item.realOutputTaxRate,
          approvedName: item.approvedDrugNames,
          spec: item.specifications,
          producer: item.manufacturer,
          origin: item.countryOfOrigin,
          goodsType: item.type,
        });
      });
      this.submitLoading = true;
      this.$store.commit('setDisableLoading', true);
      toolsService.outputTaxRateUpdateSubmit({ operateGoodsKeyVoList: params }).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('提交成功');
          setTimeout(() => {
            this.handleToList();
          }, 1000);
        } else {
          this.$Message.error(res.data.error);
        }
        this.submitConfirmVisiable = false;
        this.submitLoading = false;
      }).catch((err) => {
        this.submitConfirmVisiable = false;
        this.submitLoading = false;
        utils.handleError(err);
      });
    },
    submitConfirm() {
      if (this.formModel.tableData.length === 0) {
        this.$Message.error('请先添加明细');
        return;
      }

      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitConfirmVisiable = true;
        } else {
          this.$Message.error('请按照要求填写');
        }
      });
    },
  },
  created() {
  },
};
</script>
<style lang="less" scoped>
  .red {
    color: red;
  }
</style>
